import Layout from '../../layout/index'

const newsRouter = {
  path: '/news',
  component: Layout,
  redirect: '/news/index',
  children: [
    {
      path: 'index',
      name: 'news',
      component: () => import('../../views/news/index')
    },
    {
      path: 'detail',
      name: 'newsDetail',
      component: () => import('../../views/news/detail')
    }
  ]
}
export default newsRouter
